import { simpleSet } from '@r/reducers/utils';

const setCalculationModeShippingCostValue = simpleSet as
  redux.reducers.calculationMode.settings.information.shippingCost.value;

export const value = setCalculationModeShippingCostValue(
  'SET_CALCULATION_MODE_SHIPPING_COST_VALUE',
  { label: '', value: 0 }
);
